import Switch from 'react-switch';
import { Label } from 'components/atoms/index';

interface ISwitchAtomProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  [key: string]: any;
  label?: string;
}

const SwitchInput: React.FC<ISwitchAtomProps> = ({ checked, label, onChange, ...props }) => {
  return (
    <div className='flex gap-2 items-center'>
      <Switch
        checked={checked}
        onChange={onChange}
        offColor="#888"
        onColor="#4f90ff"
        uncheckedIcon={false}
        checkedIcon={false}
        height={20}
        width={37}
        {...props}
      />
      {label && <Label color={'transparent'}>{label}</Label>}
    </div>
  )
}

export default SwitchInput;